import React, { useState, useEffect } from 'react';
import { useDeleteProduct, useDeleteAttachment, useEditProject, useAddProduct, useAddAttachment } from '../../../components/project-builder-custom-hooks';
import { useQuery } from '@tanstack/react-query';
import { getProject } from '../../../apis/project-builder';
import Modal from 'react-modal';
import { useCurrentProjectIdContext, useTranslationContext, translateProjectType, translateProjectStatus } from "./project-builder-main.jsx";
import { formatCurrency } from './utilities.jsx';

export default function OverviewModal({ projectId, isOpen, closeOverviewModal }) {
    const { translations, culture, conversionFactor } = useTranslationContext();

    //type can be project, product, or family
    //change text accordingly
    Modal.setAppElement('#main');

    const { currentProjectId } = useCurrentProjectIdContext();

    const { data, isSuccess, isLoading, isError, error } = useQuery(['project-detail', projectId], _ => {
        return projectId ? getProject(projectId) : null;
    });

    const projectCost = _ => {
        let projectCost = parseFloat(data.totalProductPrice) + parseFloat(data.freight) + parseFloat(data.salesTax);
        return formatCurrency(projectCost);
    }

    useEffect(() => {

    }, [data]);

    return (
        <>
            {data &&
                <Modal
                    width="800px"
                    isOpen={isOpen}
                    onRequestClose={closeOverviewModal}
                    className="project-builder project-builder-modal project-builder-modal--large"
                >

                    <button className="project-builder-modal-close" onClick={closeOverviewModal}>
                        <svg id="header-ask-close-svg" className="icon icon-close"><use xlinkHref="#icon-close"></use></svg>
                    </button>

                    <div className="container text-center">
                        <div className='modal-title mb-2'>{data.projectName} {translations.Overview}</div>
                        <div className="project-builder-overview text-left">

                            <div className="overview-row">
                                <div className="overview-container">
                                    <div className="label">{translations.ProjectName}</div>
                                    {data.name}
                                </div>

                                <div className="overview-container">
                                    <div className="label">{translations.ProjectId}</div>
                                    {data.id}
                                </div>

                                <div className="overview-container">
                                    <div className="label">{translations.Accountname}</div>
                                    {data.accountName}
                                </div>

                                <div className="overview-container">
                                    <div className="label">{translations.ZipCode}</div>
                                    {data.zipCode}
                                </div>

                                <div className="overview-container">
                                    <div className="label">{translations.PhoneNumber} <span>({translations.Customer})</span></div>
                                    {data.contactPhoneNumber}
                                </div>

                                <div className="overview-container">
                                    <div className="label">{translations.EmailAddress} <span>({translations.Customer})</span></div>
                                    {data.contactEmailAddress}
                                </div>
                            </div>

                            <div className="overview-divider"></div>

                            <div className="overview-row">
                                <div className="overview-container">
                                    <div className="label">{translations.ProjectStatus}</div>
                                    {translations[translateProjectStatus(data.status)] ?? data.status}
                                </div>

                                <div className="overview-container">
                                    <div className="label">{translations.ProjectType}</div>
                                    {translations[translateProjectType(data.type)] ?? data.type}
                                </div>

                                <div className="overview-container">
                                    <div className="label">{translations.ProjectFormat}</div>
                                    {data.isMarketingProject ? translations.SalesProject : translations.QuoteProject}
                                </div>
                            </div>

                            <div className="overview-divider"></div>

                            <div className="overview-row">
                                <div className="overview-container">
                                    <div className="label">{translations.ProjectCost}</div>
                                    {data.isMarketingProject ? "N/A" : projectCost()}
                                </div>
                            </div>

                            <div className="overview-divider"></div>

                            <div className="notes-container" style={{ marginBottom: '30px' }}>
                                <div className="label">{translations.ProjectNotes}</div>
                                {data.notes}
                            </div>

                            <div className="overview-divider"></div>

                            <div >

                                {data.products.length > 0 &&
                                    <>
                                        <div className="row">
                                            <div className="col-2 label">{translations.SKU}</div>
                                            <div className="col-4 label">{translations.Product}</div>
                                            <div className="col-3 label text-left">{translations.Price}</div>
                                            <div className="col-1 label text-left">{translations.Qty}</div>
                                            <div className="col-2 label text-left">{translations.Total}</div>
                                        </div>

                                        {data.products.map(product => {
                                            return (
                                                <div key={product.id} className="product-row">
                                                    <div className="row">
                                                        <div className="col-2">{product.sku}</div>
                                                        <div className="col-4">{product.title}</div>
                                                        <div className="col-3 text-left">
                                                            <span>{formatCurrency(product.dealerPrice ?? product.listPrice)}</span>
                                                        </div>

                                                        <div className="col-1 text-left">{product.quantity}</div>
                                                        <div className="col-2 text-left">{formatCurrency(product.dealerPrice ?? product.listPrice * product.quantity)}</div>
                                                    </div>

                                                    <div>
                                                        {product.accessories.map(accessory => {
                                                            return (
                                                                <div className="row" style={{ color: '#949292', marginTop: '10px' }}>
                                                                    <div className="col-2">{accessory.sku}</div>
                                                                    <div className="col-4">
                                                                        <img src='/img/icons8-attachment-24.png' style={{ height: '16px', width: '16px' }} />
                                                                        {accessory.title}
                                                                    </div>
                                                                    <div className="col-3 text-left">
                                                                        {accessory.itemDiscount ? (
                                                                            <>
                                                                                <span>{formatCurrency(accessory.netPrice)} </span>
                                                                                <span className="product-card-price--original">{formatCurrency(accessory.listPrice)}</span>

                                                                            </>
                                                                        ) : (
                                                                            <span>{formatCurrency(accessory.listPrice)}</span>
                                                                        )
                                                                        }
                                                                    </div>

                                                                    <div className="col-1 text-left">{accessory.quantity}</div>
                                                                    <div className="col-2 text-left">{formatCurrency(accessory.netPrice * accessory.quantity)}</div>
                                                                </div>
                                                            )
                                                        })}
                                                    </div>


                                                </div>

                                            )
                                        })}

                                    </>
                                }
                            </div>

                            <button className='btn btn-outline-alt' type='button' onClick={closeOverviewModal}>{translations.CloseOverview}</button>
                        </div>
                    </div>
                </Modal>
            }
        </>
    );
}